import FilesCard from '@components/cards/files/Files.card';
import SelectFileComponent from '@components/inputs/selectFile/SelectFile.component';
import TextFieldComponent from '@components/inputs/textField/TextField.component';
import { Sizes } from '@constants/sizes.constants';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { CreateAuditInformation } from '@store/audits/audits-information/audits-information.model';
import { DocumentInfo, DocumentKind, filesService } from '@store/files';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';


interface PreAuditProps {
  updateAuditInformation: (
    field: keyof CreateAuditInformation, value: any
  ) => void;
  auditInformation?: CreateAuditInformation;
  errors: any;
}
const AuditMap = (props: PreAuditProps) => {

  const { auditInformation, updateAuditInformation, errors } = props;
  const { enqueueSnackbar } = useSnackbar();

  const { t } = useTranslation();
  const { auditId } = useParams();

  const addDocument = (file: File) => {
    filesService.uploadFile(file, DocumentKind.ISSUE).pipe().subscribe({
      next: (document) => {
        const docs = auditInformation?.map?.addedDocuments ?? [];
        docs.push(document);
        updateAuditInformation('map', {
          addedDocuments: docs
        });
      },
      error: (err) => enqueueSnackbar(err.text, err.options),
    });
  };

  const removeDocumentFromAddedDocuments = (document: DocumentInfo) => {
    const docs = auditInformation?.map?.addedDocuments?.filter((doc) => doc.id !== document.id);
    updateAuditInformation('map', {
      addedDocuments: docs
    });
  };

  const removeDocuments = (document: number) => {
    const docs = auditInformation?.observation?.deletedDocuments ?? [];
    docs.push(document);
    updateAuditInformation('map', {
      deletedDocuments: docs
    });
  };

  useEffect(() => {
    if (auditId) {
      updateAuditInformation('map', { auditId: Number(auditId) });
    }
  }, [auditId, updateAuditInformation]);

  return (
    <>
      <Stack py="24px" pr="10px">
        <Stack py="24px" pr="10px" spacing={1.5}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography fontSize="18px" fontWeight="700">
              {t('audits.audit.map.documents')}
            </Typography>
            <SelectFileComponent handleFileSelected={addDocument} />
          </Stack>
          <Box>
            {auditInformation?.map?.addedDocuments?.length !== 0 && auditInformation?.map?.addedDocuments?.map((photo) => {
              return (
                <FilesCard document={photo} handleDeleteDocument={() => removeDocumentFromAddedDocuments(photo)} />
              );
            })}

            {auditInformation?.map?.documents?.length !== 0 && auditInformation?.map?.documents?.map((photo) => (
              !auditInformation?.map?.deletedDocuments?.includes(photo.id) && (
                photo.name && (
                  <FilesCard document={photo} handleDeleteDocument={() => removeDocuments(photo.id)} />
                )
              )
            ))}
          </Box>
          <Divider variant="fullWidth" orientation="horizontal" />
          <TextFieldComponent
            multiline
            color="primary"
            labelWidth={Sizes.drawerInputLabelWidth}
            placeholder={t('audits.audit.map.legend') + '*'}
            handleChange={(value) => updateAuditInformation('map', { legend: value })}
            rows={10}
            value={auditInformation?.map?.legend}
            required={true}
            error={errors.legend}
          />
          <Divider variant="fullWidth" orientation="horizontal" />
        </Stack>
      </Stack>
    </>
  );
};

export default AuditMap;
